import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormsModule,
  NgForm,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToasterService } from "@app/shared/services/toaster.service";
import { AuthService } from "@app/auth/services/auth-service.service";
import { error_msg, notification_msg } from "@app/shared/constants/consts";

export interface ForgetPasswordFormFields {
  email: any;
}
@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html"
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {
  forgetPasswordObject = { email: "" };

  forgetPasswordResetForm: FormGroup;
  loading = false;
  errorMsg = error_msg;

  initData: ForgetPasswordFormFields = {
    email: ""
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toasterService: ToasterService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    document.getElementsByTagName("body")[0].classList.add("loginpage");
    this.createForm();
  }

  createForm() {
    this.forgetPasswordResetForm = this.fb.group({
      email: [
        this.initData.email,
        Validators.compose([
          Validators.required,
          Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/),
          Validators.maxLength(100)
        ])
      ]
    });
  }

  onSubmit() {
    this.loading = true;
    if (this.forgetPasswordResetForm.valid) {
      const formVal = this.forgetPasswordResetForm.value;
      const formData = {};
      for (const key in formVal) {
        if (formVal.hasOwnProperty(key)) {
          {
            formData[key] = formVal[key];
          }
        }
      }
      this.auth.forgetPassword(formData).subscribe(
        (result: any) => {
          if (result.success === true) {
            this.toasterService.Success(result.message);
          } else {
            this.toasterService.Error(result.message);
          }
          this.loading = false;
        },
        err => {
          this.toasterService.Error(err.error.message);
          this.loading = false;
        }
      );
    } else {
      this.toasterService.Error(notification_msg.FILL_ALL_DETAILS);
      Object.keys(this.forgetPasswordResetForm.controls).forEach(key => {
        const control = this.forgetPasswordResetForm.get(key);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  ngOnDestroy() {
    document.getElementsByTagName("body")[0].classList.remove("loginpage");
  }

  get email() {
    return this.forgetPasswordResetForm.get("email");
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forget-password/forget-password.component.ts